import React, {useState} from "react";
import {Col, Row} from "reactstrap";
import {UploadStates, WarrantyAndReturnMessageSenderTypes, WarrantyAndReturnMessageTypes} from "../../../../../../core/constants/enums";
import IconButton from "../../../../base/button/icon_button";
import {CircularProgress, Fade, SvgIcon} from "@mui/material";
import {ReactComponent as Remove} from "../../../../../../assets/images/remove.svg";
import {Autorenew, CheckCircleOutline, ErrorOutline, Share} from "@mui/icons-material";
import {ReactComponent as Pdf} from "../../../../../../assets/images/warranty-files/pdf.svg";
import {ReactComponent as Video} from "../../../../../../assets/images/warranty-files/video.svg";
import {ReactComponent as Unknown} from "../../../../../../assets/images/warranty-files/php.svg";
import {ReactComponent as Zip} from "../../../../../../assets/images/warranty-files/zip.svg";
import classnames from "classnames";
import FilePreviewModal, {FilePreviewTypes} from "../../../../dialogs/file-preview";
import {openLinkInNewTab} from "../../../../../../core/services/utils/utils";
import ElementIds from "../../../../../../core/models/element-ids";

const FileBubble = ({
                        data,
                        removeMessage,
                        sendAgain,
                        className = '',
                        forward,
                        canForward,
                        typeId,
                        ...props
                    }) => {
    const [removing, setRemoving] = useState(false);
    const [sending, setSending] = useState(false);
    const [forwarding, setForwarding] = useState(false);
    const [hover, setHover] = useState(false);
    const [preview, setPreview] = useState({open: false, data: null});

    const isFromUserChat = !!props['old-structure'];
    const forwardedData = data.forwardedMsgInfo;
    const shouldUseOldStructure = isFromUserChat || !!forwardedData;

    let isFromCurrent = data.senderTypeID === WarrantyAndReturnMessageSenderTypes.operator;
    let isFromSystem = data.senderTypeID === WarrantyAndReturnMessageSenderTypes.system;
    if (!isFromUserChat) {
        isFromCurrent = !!data.operator;
    }

    /**
     * Gets the file image appropriate to the type of the file.
     * @return {JSX.Element}
     */
    const getFile = () => {
        switch (typeId) {
            case WarrantyAndReturnMessageTypes.pdf:
                return <Pdf className={'file-icon'}/>;
            case WarrantyAndReturnMessageTypes.video:
                return <Video className={'file-icon'}/>;
            case WarrantyAndReturnMessageTypes.zip:
                return <Zip className={'file-icon'}/>;
            default:
                return <Unknown className={'file-icon'}/>;
        }
    }

    /**
     * Fetch the preview data of the file
     * @return {{fileName, type: string, url}}
     */
    const getPreviewData = () => {
        let type;
        switch (typeId) {
            case WarrantyAndReturnMessageTypes.pdf:
                type = FilePreviewTypes.pdf;
                break;
            case WarrantyAndReturnMessageTypes.video:
                type = FilePreviewTypes.video;
                break;
            default:
                type = FilePreviewTypes.unknown;
                break;
        }
        return {
            url: data.data,
            type: type,
            fileName: data.fileName,
        }
    }


    /**
     * Based on the state of the data and its type, determines the functionality of file clicks
     */
    const onFileClicked = () => {
        if (data.uploadState?.state !== UploadStates.done) return
        if (typeId === WarrantyAndReturnMessageTypes.zip) {
            return openLinkInNewTab(data.data)
        }
        setPreview({
            open: true,
            data: getPreviewData()
        })
    }

    return (
        <>
            <Row
                id={shouldUseOldStructure
                    ? `${forwardedData?.submitDateTime?.toString() ?? data.submitDateTime?.toString()}-${forwardedData?.typeID ?? data.typeID}`
                    : `${data.submittedDateTime.toString()}-${data.msgType.id}`}
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
                className={`w-100 no-gutters my-3 ${isFromCurrent ? 'justify-content-end' : 'justify-content-start'} ${className}`}
            >
                {
                    isFromCurrent
                    && !isFromSystem
                    && isFromUserChat
                    && canForward
                    && data.uploadState?.state === UploadStates.done
                    && (
                        <Fade in={hover} unmountOnExit mountOnEnter>
                            <div className={'col justify-content-end align-items-center row no-gutters flex-grow-0'}>
                                <IconButton
                                    className={'mr-1'}
                                    disabled={removing || sending || forwarding}

                                    onPressed={() => forward(data, setForwarding)}
                                    color={'paper.secondary'}
                                >
                                    <Share className={'icon normal'}/>
                                </IconButton>
                            </div>

                        </Fade>
                    )
                }
                {
                    isFromCurrent
                    && !isFromSystem
                    && data.uploadState?.state === UploadStates.done
                    && (
                        <Fade in={hover} unmountOnExit mountOnEnter>
                            <div className={'col justify-content-end align-items-center row no-gutters flex-grow-0'}>
                                <IconButton
                                    className={'mr-2'}
                                    disabled={removing || sending}

                                    onPressed={() => removeMessage(data, setRemoving)}
                                    color={'paper.error'}
                                >
                                    <SvgIcon className={'icon normal'} component={Remove}/>
                                </IconButton>
                            </div>

                        </Fade>
                    )
                }
                <div>
                    <div
                        className={classnames(`file rounded-xxl p-3`, {
                            "isFromCurrent": isFromCurrent,
                            "cursor-progress-hover": data.uploadState?.state === UploadStates.pending,
                            "cursor-pointer-hover": data.uploadState?.state === UploadStates.done,
                            "cursor-default-hover": data.uploadState?.state !== UploadStates.error
                                && data.uploadState?.state !== UploadStates.pending
                        })}
                        onClick={onFileClicked}
                        style={{
                            maxWidth: (document.getElementById(ElementIds.partSupportChat.body)?.clientWidth ?? 100) / 2,
                        }}>
                        <div className={'d-flex align-items-center'}>
                            {getFile()}
                            <p className={`text-sm text-left text-wrap ${isFromCurrent ? 'white' : 'text-color-1'}`}>
                                {data?.fileName ?? ''}
                            </p>
                        </div>
                    </div>
                    {
                        !!forwardedData &&
                        <Col
                            xs={12}
                            className={`d-flex p-0 ${isFromCurrent ? 'justify-content-start' : 'justify-content-end'}`}
                        >
                            <p className={'text-xs text-color-3 ml-2 mt-1'}>Forwarded</p>
                        </Col>
                    }
                </div>

                {
                    isFromCurrent
                    && !isFromSystem
                    && (
                        <div className={'d-flex flex-column align-items-end justify-content-end ml-1'}>
                            <Fade
                                in={(data.uploadState?.state === UploadStates.error || data.imageUploadState?.state === UploadStates.error)}
                                unmountOnExit mountOnEnter>
                                <ErrorOutline className={'icon red small'}/>
                            </Fade>
                            <Fade in={data.uploadState?.state === UploadStates.done} unmountOnExit mountOnEnter>
                                <CheckCircleOutline className={'icon stroke-grey-1 small'}/>
                            </Fade>
                            <Fade
                                in={(data.uploadState?.state === UploadStates.pending || data.imageUploadState?.state === UploadStates.pending)}
                                unmountOnExit mountOnEnter>
                                <CircularProgress color={'secondary'} size={15}/>
                            </Fade>
                        </div>
                    )
                }
                {
                    !isFromCurrent
                    && !isFromSystem
                    && isFromUserChat
                    && canForward
                    && data.uploadState?.state === UploadStates.done
                    && (
                        <Fade in={hover} unmountOnExit mountOnEnter>
                            <div className={'div justify-content-end align-items-center row no-gutters flex-grow-0'}>
                                <IconButton
                                    className={'ml-1'}
                                    disabled={removing || sending || forwarding}

                                    onPressed={() => forward(data, setForwarding)}
                                    color={"paper.secondary"}
                                >
                                    <Share className={'icon normal'}/>
                                </IconButton>
                            </div>

                        </Fade>
                    )
                }
                {
                    !isFromCurrent
                    && !isFromSystem
                    && data.uploadState?.state === UploadStates.done
                        ? (
                            <Fade in={hover} unmountOnExit mountOnEnter>
                                <div className={'col justify-content-end align-items-center row no-gutters flex-grow-0'}>
                                    <IconButton
                                        className={'ml-2'}
                                        disabled={removing || sending}

                                        onPressed={() => removeMessage(data, setRemoving)}
                                        color={'paper.error'}
                                    >
                                        <SvgIcon className={'icon normal'} component={Remove}/>
                                    </IconButton>
                                </div>

                            </Fade>
                        )
                        : isFromCurrent
                        && !isFromSystem
                        && data.uploadState?.state === UploadStates.error
                        && (
                            <Fade
                                in={(data.uploadState?.state === UploadStates.error || data.imageUploadState.state === UploadStates.error) && hover}
                                unmountOnExit mountOnEnter>
                                <div className={'col justify-content-end align-items-center row no-gutters flex-grow-0'}>
                                    <IconButton
                                        className={'ml-2'}
                                        disabled={sending || removing}

                                        onPressed={() => sendAgain(data, setSending)}
                                        color={'paper.secondary'}
                                    >
                                        <Autorenew className={'icon normal'}/>
                                    </IconButton>
                                </div>
                            </Fade>
                        )
                }
            </Row>
            <FilePreviewModal
                setOpen={(open) => setPreview({open: open, data: null})}
                open={preview.open}
                data={preview.data}
            />
        </>
    );
}

export default FileBubble;
